import axios from 'axios'
import qs from 'qs'

//axios.defaults.baseURL = 'https://localhost:44391'
axios.defaults.baseURL = 'http://webapi.sritrang.cn'
axios.defaults.timeout = 10000;
axios.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded;charset=UTF-8";

axios.interceptors.request.use(
    config => {
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

axios.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        console.log("网络请求失败，反馈给客服" + error)
    }
);

function request(url, params, method) {
    let data = method == "post" ? qs.stringify(params) : Object.assign(params)
    console.log( data)
    return new Promise((resolve, reject) => {
        axios({
            method: method,
            url: url,
            data: data
        })
            .then(res => {
                console.log(res)
                if (res != null && res.data != null && res.data.status == 200) {
                    resolve(res.data)
                } else {
                    reject(res.data.msg || '系统错误');
                }
            })
            .catch(err => {
                console.log(err);
                reject(err || '请求失败');
            });
    })
}

async function post(url, params) {
    return request(url, params, "post");
}

async function get(url, params) {
    return request(url, params, "get");
}

export default {post, get}